import { DisplayText, HeadlineText } from "@classdojo/web/nessie";
import React from "react";
import { formatTime } from "utils";

type CountdownTimeProps = {
  seconds: number;
};

type CountdownTimeState = {
  displayZero: boolean;
};

// eslint-disable-next-line react-prefer-function-component/react-prefer-function-component
export default class CountdownTime extends React.Component<CountdownTimeProps, CountdownTimeState> {
  constructor(props: CountdownTimeProps) {
    super(props);
    this.state = { displayZero: true };
  }

  componentWillUnmount() {
    this.blinkInterval && clearInterval(this.blinkInterval);
    this.blinkInterval = undefined;
  }

  render() {
    if (this.props.seconds > 0) {
      return (
        <div
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            marginTop: "dt_m",
            position: "relative",
          }}
        >
          <DisplayText>{formatTime(this.props.seconds)}</DisplayText>
        </div>
      );
    }

    if (!this.blinkInterval) {
      this.blinkInterval = setInterval(this.blink, 500);
    }

    return (
      <div
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          flexGrow: 1,
          marginTop: "dt_m",
          position: "relative",
        }}
      >
        <HeadlineText as="h2" level={2}>
          Time's up!
        </HeadlineText>
        <DisplayText kind={this.state.displayZero ? "danger" : "light"} sx={{ display: "hidden" }}>
          {this.props.seconds}
        </DisplayText>
      </div>
    );
  }

  blinkInterval: NodeJS.Timeout | undefined;

  blink = () => {
    this.setState((state) => ({ displayZero: !state.displayZero }));
  };
}
